import { useState } from "react";

// 관리자가 비밀번호를 초기화한 계정이 로그인했을 때 강제로 뜨는 화면.
//   비밀번호를 바꾸기 전에는 이 화면을 벗어날 수 없다(서버에서도 다른 요청을 막는다).
export default function ForcePasswordChange({ userName, apiBase = "", onDone, onLogout }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setMsg("모든 항목을 입력해주세요.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setMsg("새 비밀번호가 서로 다릅니다.");
      return;
    }
    if (newPassword === currentPassword) {
      setMsg("초기 비밀번호와 다른 비밀번호를 입력해주세요.");
      return;
    }

    setSaving(true);
    try {
      const res = await fetch(`${apiBase}/api/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ currentPassword, newPassword, confirmPassword }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setMsg(data.message || "비밀번호 변경에 실패했습니다.");
        return;
      }
      await onDone?.();
    } catch (err) {
      setMsg("비밀번호 변경 중 오류가 발생했습니다.");
    } finally {
      setSaving(false);
    }
  };

  const inputClass =
    "w-full rounded-xl border border-gray-300 px-4 py-3 text-sm outline-none focus:border-blue-500 dark:border-gray-600 dark:bg-[#16202C] dark:text-white";

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-[#0A0F1F]">
      <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-xl dark:bg-[#1F2A3B] sm:p-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">비밀번호 변경</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-600 dark:text-gray-300">
          {userName ? `${userName} 님, ` : ""}관리자가 비밀번호를 초기화했습니다.
          <br />
          <b>새 비밀번호로 변경해야 이용할 수 있습니다.</b>
        </p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <div>
            <label className="mb-1 block text-xs font-semibold text-gray-500 dark:text-gray-400">
              현재 비밀번호
            </label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="관리자에게 받은 비밀번호"
              className={inputClass}
              autoComplete="current-password"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold text-gray-500 dark:text-gray-400">
              새 비밀번호
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={inputClass}
              autoComplete="new-password"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold text-gray-500 dark:text-gray-400">
              새 비밀번호 확인
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={inputClass}
              autoComplete="new-password"
            />
          </div>

          {msg && (
            <div className="rounded-xl bg-red-50 px-4 py-3 text-sm font-semibold text-red-600 dark:bg-red-900/20 dark:text-red-300">
              {msg}
            </div>
          )}

          <button
            type="submit"
            disabled={saving}
            className="w-full rounded-xl bg-blue-600 px-5 py-3 font-semibold text-white hover:bg-blue-700 disabled:opacity-60"
          >
            {saving ? "변경 중..." : "변경하기"}
          </button>
        </form>

        <button
          type="button"
          onClick={onLogout}
          className="mt-4 w-full text-center text-xs text-gray-500 underline underline-offset-2 hover:text-gray-700 dark:text-gray-400"
        >
          로그아웃
        </button>
      </div>
    </div>
  );
}
